import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

import {ListItemType} from './commonTypes'

export enum TabKeyEnum {
  junior_gift = 0,
  senior_gift = 1,
}
// 获取 基础盲盒和高级盲盒的活动id https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=25152804
export const blind_box_base_id = createAsyncThunk(
  'blind_box_base_id',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'junior_gift' | 'senior_gift' | 'rank_id' | 'room_list'
        >
      >
    >(
      '/live/activity/act_blind_box_base_id',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 输入活动Id 获取当前活动兑换规则信息、个人收集状态 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=25152300
export const blind_box_status = createAsyncThunk(
  'blind_box_status',
  async (tabKey: TabKeyEnum, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<InitialStateType, 'gift_list' | 'receive_gift' | 'exchange_list'>
      >
    >(
      '/live/activity/act_blind_box_status',
      {
        act_id: store.getState().WildBlindBox[TabKeyEnum[tabKey]],
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 碎片兑换 输入活动Id 和兑换规则 id   https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=25152372
export const blind_box_exchange = createAsyncThunk(
  'blind_box_exchange',
  async (arg: {tabKey: TabKeyEnum; rule_id: number}, store: any) => {
    const {tabKey, rule_id} = arg
    const resp = await http.post<HiyaRes<{ret: -1 | 1; err_msg: string}>>(
      '/live/activity/act_blind_box_exchange',
      {
        act_id: store.getState().WildBlindBox[TabKeyEnum[tabKey]],
        rule_id,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取排行榜单 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=17589174
export const get_board = createAsyncThunk(
  'get_board',
  async (tabKey: number, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'own' | 'list'>>
    >('/live/commonactivity/get_board', {
      activity_id: store.getState().WildBlindBox.rank_id[tabKey],
      offset: 0,
      // 一次性取50条出来
      pageSize: 50,
      // 0表示本周
      periodOffset: 0,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

interface HiyaRes<T> {
  ret: number
  data: T
}
interface GiftItemType {
  id: number
  // 图片名字
  name: string
  // 收集成功的礼物图片
  url: string
  // 已经获得的个数和天数
  is_own: boolean
}
interface RecievedItemType {
  id: number
  // 图片名字
  name: string
  // 收集成功的礼物图片
  url: string
  // 已经获得的个数和天数
  num: number
}
export interface BlindBoxesItemType {
  // 单个礼物的兑换规则 id
  rule_id: number
  // 礼物名称
  gift_name: string
  // 能兑换的礼物id
  gift_id: number
  // 能兑换的礼物id数量
  gift_cnt: number
  // 礼物链接
  gift_img: string
  // 礼物价值
  gift_cost: number
  // 需要消耗的礼物
  cost_list: Array<{name: string; url: string}>
  exchange_able: boolean
}
interface InitialStateType {
  tabKey: TabKeyEnum
  junior_gift?: number
  senior_gift?: number
  junior_gift_id?: number
  senior_gift_id?: number
  // rank list的列表 id
  rank_id?: Array<number>
  // 推荐房间列表
  room_list?: Array<{room_id: number; avatar: string}>
  // 可以兑换的盲盒
  exchange_list?: Array<BlindBoxesItemType>
  // 需要收集的礼物列表
  gift_list?: Array<GiftItemType>
  // 获得的盲盒和头像框列表
  receive_gift?: Array<RecievedItemType>
  // 排名中的我的个人信息
  own?: ListItemType
  list?: Array<ListItemType>
}
const initialState: InitialStateType = {
  tabKey: TabKeyEnum.junior_gift,
}
export const WildBlindBoxSlice = createSlice({
  name: 'WildBlindBox',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(blind_box_base_id.fulfilled, (state, action) => {
      const {rank_id, room_list, ...rest} = action.payload
      // 防止数组返回null，直接重置成[]
      const ret = {
        rank_id: rank_id || [],
        room_list: room_list || [],
      }
      Object.assign(state, ret, rest)
    })
    builder.addCase(blind_box_status.fulfilled, (state, action) => {
      // 后端回传数组的时候空数组直接给的null
      const ret = {
        gift_list: action.payload.gift_list || [],
        receive_gift: action.payload.receive_gift || [],
        exchange_list: action.payload.exchange_list || [],
      }
      Object.assign(state, ret)
    })
    builder.addCase(get_board.fulfilled, (state, action) => {
      // 后端回传数组的时候空数组直接给的null
      const ret: any = {
        list: action.payload.list || [],
      }
      if (action.payload.own) {
        ret.own = action.payload.own
      }
      Object.assign(state, ret)
    })
  },
})
export default WildBlindBoxSlice.reducer
